module.exports = __webpack_public_path__ + "public/static/aboutBgOne.svg?9e7f299a";